import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=1d5a21d7&scoped=true&lang=pug&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5a21d7",
  null
  
)

export default component.exports